<template>
  <span>
    <highcharts :options="chartOptions" :deepCopyOnUpdate="false" />
  </span>
</template>

<script>
  import columnChartMixin from "./columnChartMixin";

  export default {
    name: "ChartPrazoMedioReclamacoesImprocedentesEncerradasPorCompetencia",
    mixins: [columnChartMixin],
    props: {
      dadosPorCompetencia: {
        type: Object,
        required: true,
      },
      categories: {
        type: Array,
        required: true
      }
    },
    data: () => ({
      chartOptions: {},
    }),
    methods: {
      setChartOptions() {
        this.chartOptions = this.getColumnChartOptions(
          this.getPrazoMedioReclamacoesImprocedentesEncerradasPorCompetenciaRemainingChartOptions()
        );
      },
      getPrazoMedioReclamacoesImprocedentesEncerradasPorCompetenciaRemainingChartOptions() {
        return {
          xAxis: {
            type: "category",
            title: {
              text: "Competência",
            },
          },
          series: [
            {
              name: "Valor",
              data: this.categories
                .map((category) => {
                  return category in this.dadosPorCompetencia
                    ? {
                        name: category,
                        y: Number(
                          this.dadosPorCompetencia[category]
                            .prazo_medio_total_reclamacoes_improcedentes_encerradas
                        ),
                      }
                    : {
                        name: category,
                        y: 0,
                      };
                })
                .filter((val) => val !== null && val.y !== null && val.y > 0),
            },
          ],
        };
      },
    },
    watch: {
      dadosPorCompetencia() {
        this.setChartOptions();
      },
    },
  };
</script>

<style></style>
